ConnectStore = require 'components/enhancers/connect_store'
{ get } = require 'lodash'
{ MDA_HANDOUT } = require 'lib/db_docs/doc_types'
MdaTopicsStore = require 'stores/mda_topics_store'
QuestionsStore = require 'stores/questions_store'
{ useCoffeeMemo } = require 'lib/react_utils'

storeConnector =
  MdaTopicsStore: (Store) ->
    topics: Store.getTopics()
  QuestionsStore: (Store) ->
    handouts: Store.getQuestions()

# value will be the topic id
TopicSelectorField = ({ data, handouts, onChange, topics }) ->
  value = get data, 'options.parentTopicId'
  
  topicIdsWithHandouts = useCoffeeMemo [handouts], ->
    handouts.reduce (acc, doc) ->
      return acc unless doc.get('docType') is MDA_HANDOUT
      parentTopicId = doc.getIn(['options', 'parentTopicId'])
      if parentTopicId
        acc.add parentTopicId
      else
        acc
    , Immutable.Set()

  <div className="topic-selector-field">
    <ul className="standard-list">
      {topics.size is 0 and <li>{$.t 'mda:handouts.no_topics'}</li>}
      {topics.map (topic) ->
        topicId = topic.get('_id')
        hasHandoutInCurrentProject = topicIdsWithHandouts.has(topicId)
        disabled = not _.isEmpty(data._id) or hasHandoutInCurrentProject
        rowClassName = classNames 'flex flex-row items-center', 'is-disabled': disabled
        <li className={rowClassName} key={topicId}>
          <label className="flex flex-row items-center">
            <input
              type="radio"
              name="topic"
              value={topicId}
              onChange={-> onChange(topic)}
              checked={value is topicId}
              disabled={disabled}
            />
            {topic.get('name')}
          </label>
        </li>
      }
    </ul>
  </div>

module.exports = ConnectStore TopicSelectorField, [MdaTopicsStore, QuestionsStore], storeConnector
